import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ShareDataServiceService } from '../../services/share-data-service.service';
import { ajax, AjaxRequest } from 'rxjs/ajax';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Tender } from 'src/app/models/Tender.class';
import { TenderStatus } from 'src/app/models/TenderStatus.class';
import { TenderFileType } from 'src/app/models/TenderFileType.class';
import { SelectTenderEventProps } from 'src/app/models/SelectTenderEventProps.class';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-tenders',
  templateUrl: './tenders.component.html',
  styleUrls: ['./tenders.component.css'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1}),
          animate('500ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    ),
    trigger(
      'leaveAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0, left:1}),
          animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1, left:0}),
          animate('500ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    )
  ]
})
export class TendersComponent implements OnInit {

  constructor(private http: HttpClient,private shareDataService:ShareDataServiceService, private route:ActivatedRoute, private recaptchaV3Service: ReCaptchaV3Service, private router:Router) {
    
  }

  tenders: Tender[] = [];
  TenderStatuses: any[] = [];
  pageSize:number =10;
  loading:boolean=true;
  error:string='';
  close:boolean = false;

  resultCountMsg:string='';
  showExSearch:boolean = false;
  searchObj:any={
    FreeText:null,
    Title:null,
    MolsaTenderNumber:null,
    MolsaTenderStatus:[1,4,5],
    MolsaTenderPublishDate_start:null,
    MolsaTenderPublishDate_end:null,
    MolsaProposalHandingDate_start:null
  };
  orderBy:string='MolsaTenderNumber';
  orgData:any[]=[];
  showMoreTender:number=-1;
  //viewTendersSettings:any={columns:[],data:[],pageSize:10,loading:true};

  selectedTenderProps:SelectTenderEventProps = new SelectTenderEventProps();

  ngOnInit(): void {
    //אם מדובר בהפניה ישירה למכרז מסוים
    const query:string[]=window.location.search.toLocaleLowerCase().split('tenderid=');
    if(query.length>1 && !isNaN(parseInt(query[1]))){
      this.router.navigateByUrl('/tender/'+query[1]);
    }
    let curHref = window.location.href;
    this.close = curHref.indexOf('/tender/')>-1 || curHref.indexOf('/registration/')>-1 || curHref.indexOf('/questions/')>-1;
    this.router.events.subscribe(r =>{
      if((r instanceof NavigationEnd)){
        curHref = r.urlAfterRedirects;
        this.close = curHref.indexOf('/tender/')>-1 || curHref.indexOf('/registration/')>-1 || curHref.indexOf('/questions/')>-1;
      }
    });
    this.recaptchaV3Service.execute('importantAction')
    .subscribe((token: any) => {
        this.http.post(environment.serviceUrl+'/api/tenders/Active',{CaptchaToken:token})
      .subscribe((res:any)=> {
          //this.shareDataService.set('tenders',res);//so big
          this.tenders = res;
          const arrOptions:Array<any> = this.tenders.filter(x=>x.MolsaTenderStatus).map(x=>{ return {key:x.MolsaTenderStatus,value:(x.TenderStatus!).TenderStatusDesc}});
          this.TenderStatuses = arrOptions.filter(this.onlyUnique);
          this.tenders.forEach(row=>{
            //row[col.field] = this.getDateSpan(row[col.field]);
            Object.defineProperty(row,'MolsaTenderPublishDate_text',{value:this.getDateSpan((row.MolsaTenderPublishDate!)),enumerable: true});
            Object.defineProperty(row,'MolsaProposalHandingDate_text',{value:this.getDateSpan((row.MolsaProposalHandingDate!)),enumerable: true});
          });
          this.tenders = JSON.parse(JSON.stringify(this.tenders));
          this.orgData = this.tenders.filter(x=>true);
          this.filterByParamOrStorage();
          this.loading = false;
          this.loadMoreTenders(0,200, token);
          /*this.viewTendersSettings={
            columns:[
              {field:'Title', title:'נושא', type:'linkTitle', searchable:true, url: '/tender', params:[{name:'id',field:'TenderId'}]},
              {field:'MolsaTenderNumber', title:'מספר מכרז', type:'string', searchable:true},
              {field:'MolsaTenderStatus', title:'סטטוס', type:'lookup', params:{object:'TenderStatus',key:'TenderStatusId',value:'TenderStatusDesc'}, searchable:true, design:'status'},
              {field:'MolsaTenderPublishDate', title:'מועד פרסום', type:'date_range', searchable:true},
              {field:'MolsaProposalHandingDate', title:'מועד הגשה אחרון', type:'date_end', searchable:true},
              //{field:'MolsaTenderPayment', title:'סכום לתשלום', type:'payment',params:{encryptPaymentCol:'MolsaTenderEncryptedPayment'}, searchable:false},
              {field:'MolsaTenderInManof', title:'קישור למכרז במנו"ף', type:'string'},
              //{field:'RegistrationRouterLink', title:'', type:'routerLink', url: '/registration', text:'רישום לקבלת עדכונים', params:[{name:'id',field:'TenderId'}]},
              //{field:'MolsaTenderQADate', title:'מועד אחרון לשאלות הבהרה', type:'date', searchable:false},
              //{field:'QuestionsRouterLink', title:'', type:'routerLink', url: '/questions', text:'מילוי שאלות הבהרה', params:[{name:'id',field:'TenderId'}], condition:{type:'date',compare:'<=',field:'MolsaTenderQADate',value:new Date().toJSON(),expiredText:'תם המועד'}},
              //{field:'MoreInfoRouterLink', title:'', type:'routerLink', url: '/tender', text:'פרטים נוספים', params:[{name:'id',field:'TenderId'}]}
            ],
            data:this.tenders,
            pageSize:10,
            mode:'view',
            searchAlign:'top',
            loading: false
          };*/
        },err=>{
          console.log(err);
          //this.viewTendersSettings={columns:[],data:[],pageSize:10,loading:false,error:'חלה תקלה, נא נסו מאוחר יותר.'};
          this.loading = false;
          this.error = 'חלה תקלה, נא נסו מאוחר יותר.';
        });
    });//ORIT
    this.removeDateInputPopup(0);
  }

  removeDateInputPopup(count:number):void{
    if(document.querySelectorAll('input[aria-haspopup="dialog"]').length>0)
      document.querySelectorAll('input[aria-haspopup="dialog"]').forEach(x=>x.removeAttribute('aria-haspopup'));
    else if(count<10)
      setTimeout(()=>this.removeDateInputPopup(count+1),1000);
  }

  moreTenders:Tender[]=[];

  loadMoreTenders(skip:number,take:number, token:string): void {
    this.recaptchaV3Service.execute('importantAction').subscribe((token: any) => {
      this.http.post(environment.serviceUrl+'/api/tenders/'+skip+'/'+take,{CaptchaToken:token})
      .subscribe((res:any)=> {
        this.moreTenders = this.moreTenders.concat(res);
        if(res.length==take)
          this.loadMoreTenders(skip+take,take, token);
        else{
          this.moreTenders.forEach(row=>{
            //row[col.field] = this.getDateSpan(row[col.field]);
            Object.defineProperty(row,'MolsaTenderPublishDate_text',{value:this.getDateSpan((row.MolsaTenderPublishDate!)),enumerable: true});
            Object.defineProperty(row,'MolsaProposalHandingDate_text',{value:this.getDateSpan((row.MolsaProposalHandingDate!)),enumerable: true});
          });
          this.orgData = JSON.parse(JSON.stringify(this.moreTenders));
          this.moreTenders=[];
          const arrOptions:Array<any> = this.orgData.filter(x=>x.MolsaTenderStatus).map(x=>{ return {key:x.MolsaTenderStatus,value:(x.TenderStatus!).TenderStatusDesc}});
          this.TenderStatuses = arrOptions.filter(this.onlyUnique);
          this.filterByParamOrStorage();
        }
      },err=>{
      console.log(err);
      if((take-10)>0)
        this.loadMoreTenders(skip,take-10, token);
      });
    }); //ORIT
  }

  onlyUnique(current:any, index:number, arr:any[]) {
    return arr.findIndex(x=>x.key==current.key) === index;
  }

  getDateSpan(jsonDate:string):string{
    if(!jsonDate || jsonDate=='0001-01-01T00:00:00')
      return '';
    return '<span><style>.hiddenJsonDate{display:none}</style><span class="hiddenJsonDate">'+jsonDate+'</span>'+this.getDdMmYyyy(jsonDate)+'</span>';  
  }

  getDdMmYyyy(jsonDate:string):string{
    const split:string[] = jsonDate.split('T')[0].split('-');
    return split[2]+'/'+split[1]+'/'+split[0];
  }

  pages:number[] =[];
  setResultCountMsg():void{
    this.pages = [];
    if(this.tenders.length==0)
      this.resultCountMsg = 'לא נמצאו תוצאות';
    else{
      this.resultCountMsg = 'מציג '+((this.startPage-1)*this.pageSize+1)+' - '+((this.startPage-1)*this.pageSize+this.pageSize<this.tenders.length?(this.startPage-1)*this.pageSize+this.pageSize:this.tenders.length)+' מתוך '+this.tenders.length+' מכרזים';
      if(this.tenders.length>this.pageSize){
        for(let i=0;i<this.tenders.length;i+=this.pageSize)
          this.pages.push((i/this.pageSize)+1);
        const maxPages = window.innerWidth<500?6:20;
        if(this.pages.length>maxPages)
          this.pages = this.pages.splice(this.startPage<(maxPages/2)?0:(this.startPage<(this.pages.length-(maxPages/2))?(this.startPage-(maxPages/2)):(this.pages.length-maxPages)),maxPages);
      }
    }
  }

  startPage:number = 1;
  paging(page:number,dir:string):void{
    if(dir==''){
      this.startPage = page;
    }
    else if(page==0){//next or prev
      if(dir=='next'){
        if((this.startPage*this.pageSize+1) <= this.tenders.length)//not last page
          this.startPage++;
        else
          return;
      }
      else{//prev
        if(this.startPage==1)//fisrt page
          return;
        else
          this.startPage--;
      }
    }
    else if(page==-1){//first or last
      if(dir=='next'){
        this.startPage = Math.ceil(this.tenders.length/this.pageSize);
      }
      else{//prev
        this.startPage = 1;
      }
    }
    this.setResultCountMsg();
  }

  filterByParamOrStorage():void{
    const queryKeys:string[] = this.route.queryParams && (this.route.queryParams as any).value? Object.keys((this.route.queryParams as any).value).filter(key=>key.toLocaleLowerCase()=='tendernumber'):[];
    if(queryKeys.length>0){
      const tenderNum:string = (this.route.queryParams as any).value[queryKeys[0]];
      //אם כבר נמצאה התוצאה במכרזים הפעילים-יציאה
      if(this.tenders.length==1 && this.tenders[0].MolsaTenderNumber==tenderNum)
        return;
      this.tenders = this.orgData.filter(x=>(x.MolsaTenderNumber!)==tenderNum);
      this.setResultCountMsg();
      this.searchObj.MolsaTenderStatus = this.TenderStatuses.map(x=>x.key);
      this.searchObj.MolsaTenderNumber = tenderNum;
    }
    else{
      if(localStorage.getItem('searchObj'))
        this.searchObj = JSON.parse((localStorage.getItem('searchObj')!));
      if(localStorage.getItem('orderBy'))
        this.orderBy = (localStorage.getItem('orderBy')!);
      this.filter();
    }
  }

  filter():void{
    console.log(this.searchObj);
    this.tenders = this.orgData.filter(x=>true);
    if(this.searchObj.Title)
      this.tenders = this.tenders.filter(x=>(x.Title!).indexOf(this.searchObj.Title)>-1)
    if(this.searchObj.MolsaTenderNumber)
      this.tenders = this.tenders.filter(x=>(x.MolsaTenderNumber!).indexOf(this.searchObj.MolsaTenderNumber)>-1)    
    if(this.searchObj.MolsaTenderStatus && this.searchObj.MolsaTenderStatus.length>0)
      this.tenders = this.tenders.filter(x=>this.searchObj.MolsaTenderStatus.indexOf(x.MolsaTenderStatus)>-1)
    if(this.searchObj.MolsaTenderPublishDate_start){
      const jsonDt = this.searchObj.MolsaTenderPublishDate_start instanceof Date ? (this.searchObj.MolsaTenderPublishDate_start as Date).toJSON():this.searchObj.MolsaTenderPublishDate_start;
      this.tenders = this.tenders.filter(x=>(x.MolsaTenderPublishDate!)>=jsonDt);
    }
    if(this.searchObj.MolsaTenderPublishDate_end)
      this.tenders = this.tenders.filter(x=>(x.MolsaTenderPublishDate!)<=this.searchObj.MolsaTenderPublishDate_end)
    if(this.searchObj.MolsaProposalHandingDate_start){
      const jsonDt = this.searchObj.MolsaProposalHandingDate_start instanceof Date ? (this.searchObj.MolsaProposalHandingDate_start as Date).toJSON():this.searchObj.MolsaProposalHandingDate_start;
      this.tenders = this.tenders.filter(x=>(x.MolsaProposalHandingDate!)>=jsonDt);
    }
    if(this.searchObj.FreeText)
      this.tenders = this.tenders.filter(x=>this.isRight(x));
    localStorage.setItem('searchObj',JSON.stringify(this.searchObj));
    if(this.tenders.length<=(this.startPage-1)*this.pageSize)
      this.startPage = 1;
    this.setResultCountMsg();
    this.order();
    localStorage.setItem('orderBy',this.orderBy);
  }

  isRight(row:any):boolean{
    if(['Title','MolsaTenderNumber'].findIndex((col:any)=>row[col] && row[col].toString().indexOf(this.searchObj.FreeText)>-1)>-1)
      return true;
    return false;
  }

  clearFilter():void{
    Object.keys(this.searchObj).forEach(key=>this.searchObj[key]=null);
    this.tenders = this.orgData.filter(x=>true);
    this.setResultCountMsg();
  }

  showMore(tenderId:number){
    this.showMoreTender = this.showMoreTender!=tenderId?tenderId:-1;
  }

  order():void{
    if(this.orderBy){
      if(this.orderBy=='MolsaTenderNumber'){
        this.tenders.sort((a:Tender,b:Tender)=>{
          let partsA:string[] = (a.MolsaTenderNumber!).split('/');
          if(partsA.length==1)
            partsA = (a.MolsaTenderNumber!).split('-');
          let partsB:string[] = (b.MolsaTenderNumber!).split('/');
          if(partsB.length==1)
            partsB = (b.MolsaTenderNumber!).split('-');
          if(partsA.length>1 && partsB.length>1){
            if(parseInt(partsA[1])>parseInt(partsB[1]))
              return -1;
            if(parseInt(partsA[1])<parseInt(partsB[1]))
              return 1;
            if(parseInt(partsA[0])>parseInt(partsB[0]))
              return -1;
            if(parseInt(partsA[0])<parseInt(partsB[0]))
              return 1;
          }
          return partsA.length < partsB.length?1:partsB.length < partsA.length?-1:(a.MolsaTenderNumber!)<(b.MolsaTenderNumber!)?1:-1;
        });
      }
      else {
        if(this.orderBy.endsWith('Date'))
          this.tenders.sort((a:any,b:any)=>{return a[this.orderBy]<b[this.orderBy]?1:-1;});
        else
          this.tenders.sort((a:any,b:any)=>{return a[this.orderBy]>b[this.orderBy]?1:-1;});
      }
    }   
  }

  onSelectTender($event:any):void{
    if(window.innerWidth<500){
      this.selectedTenderProps = $event as SelectTenderEventProps;
      this.router.navigateByUrl('/tender/'+this.selectedTenderProps.SelectedTender.TenderId,{state: {tender:this.selectedTenderProps.SelectedTender}});
    }
  }

  closeDrawer():void{
    if(window.innerWidth<500 && (this.selectedTenderProps.EventType=='registration' || this.selectedTenderProps.EventType=='questions'))
      this.selectedTenderProps.EventType = 'expandTender';
    else
      this.selectedTenderProps = new SelectTenderEventProps();
  }

  getDateError(ctrlName:string):string{
    if(document.querySelector('[name="'+ctrlName+'"][aria-invalid="true"]')){
        return 'מבנה תאריך לא תקין';
    }
    return '';
  }
}
